import { Tab } from 'entities/Tab/interfaces';

export const tabs: Tab[] = [
  {
    id: 'tripsData',
    href: '/director',
    title: 'Список рейсів на завантаження',
  },
  {
    id: 'unloadTripsData',
    href: '/director/unload',
    title: 'Список рейсів на розвантаження',
  },
  {
    id: 'bookingData',
    href: '/director/booking',
    title: 'Бронювання',
  },
  {
    id: 'resourcesData',
    href: '/director/resources',
    title: 'Ресурси',
  },
  {
    id: 'smcCars',
    href: '/director/smc',
    title: 'Машини СМЦ',
  },
  {
    id: 'blackList',
    href: '/director/blackList',
    title: 'Чорний список',
  },
  {
    id: 'reportsData',
    href: '/director/reports',
    title: 'Звіти',
  },
  {
    id: 'directorSettings',
    href: '/director/setting',
    title: 'Налаштування',
  },
];
